(function () {
  var els = document.querySelectorAll('[data-countdown]');
  if (!els.length) return;
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  var timer;
  function tick() {
    var now = Date.now(), any = false;
    els.forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-countdown'));
      var s = Math.floor((end - now) / 1000);
      var out = el.querySelector('[data-cd]');
      if (s <= 0) { el.hidden = true; el.style.display = 'none'; return; }
      any = true;
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      if (out) out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(sec) + 's';
    });
    if (!any) { clearInterval(timer); location.reload(); }
  }
  timer = setInterval(tick, 1000);
  tick();
})();
